import { NavBar } from '../../molecules';
import { DropdownMenu } from '@ally/metronome-ui';
import { LI, NavLink } from '../../atoms';
import styled from 'styled-components';
import { useSession, useNav, useTransmit } from '../../../hooks';
import { INavLinkDetail } from '../../../models';
import { ISubLink } from '../../../interfaces';
import { NavSubMenuLink } from '..';

const StyledNavLink = styled(NavLink)`
  padding: 0 15px;
  :first-child {
    padding-left: 0;
  }
  :last-child {
    padding-right: 0;
  }
  ${({ theme: { colors } }): string => `
    color: ${colors['blue-800']}
  `}
`;

const StyledDropdownMenu = styled(DropdownMenu)`
  cursor: pointer;
  font-weight: 100;
  font-size: 0.93333rem;
`;

const StyledLI = styled(LI)`
  padding-left: 15px;
`;

interface INavItemProps {
  navItem: INavLinkDetail;
}

const NavItem: React.FC<INavItemProps> = ({ navItem }) => {
  const dropdownItems = (navItem.subLinks ?? []).map((subNavItem: ISubLink) => {
    return {
      variant: 'custom' as const,
      item: () => (
        <NavSubMenuLink subLink={subNavItem} key={subNavItem.title} />
      ),
      _uuid: subNavItem.title,
    };
  });

  return (
    <>
      {!navItem.subLinks && (
        <StyledNavLink
          transmitdestination={navItem.transmitdestination}
          to={navItem.link || '#'}
          text={navItem.title}
          subNav
        />
      )}
      {!!navItem.subLinks && (
        <StyledLI>
          <StyledDropdownMenu
            title={navItem.title}
            dropdownItems={dropdownItems}
            ariaLabelTrigger={(isOpen) =>
              `${isOpen ? 'Close' : 'Open'} ${navItem.title} menu`
            }
          />
        </StyledLI>
      )}
    </>
  );
};

interface IProps {}

const SubNav: React.FC<IProps> = (props) => {
  const {
    navLinkList: { subNav },
  } = useNav();
  const { isLoggedIn } = useSession();

  return (
    <NavBar isMainNav={false}>
      {isLoggedIn &&
        subNav.map((navItem: INavLinkDetail) => (
          <NavItem key={navItem.title} navItem={navItem} />
        ))}
    </NavBar>
  );
};

export default SubNav;
